import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IScrollableWrapperProps extends React.PropsWithChildren {
  className?: string;
}

export const ScrollableWrapper: React.FC<IScrollableWrapperProps> = ({ children, className }) => {
  return (
    <div className={styles['outer']}>
      <div className={cn(styles['inner'], className)}>{children}</div>
    </div>
  );
};
